import { render, staticRenderFns } from "./save-modal.vue?vue&type=template&id=a2e67218&"
import script from "./save-modal.component.ts?vue&type=script&lang=ts&"
export * from "./save-modal.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports